var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyRecommendationState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 250,
    viewBox: "0 0 476 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1496_48122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 0.380371,
    width: 240,
    height: 240,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 0.380371,
    width: 240,
    height: 240,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.616 122.808C326.616 144.16 311.295 173.198 286.397 196.927C261.517 220.638 227.173 238.95 189.269 238.95C170.31 238.95 155.433 234.848 143.776 227.721C132.12 220.594 123.649 210.421 117.532 198.225C105.288 173.812 102.5 141.336 102.5 109.134C102.5 76.9137 106.441 57.5092 119.692 46.0949C126.322 40.3837 135.328 36.6332 147.457 34.3139C159.588 31.9943 174.806 31.1129 193.829 31.1129C231.789 31.1129 265.006 43.3545 288.724 60.9519C312.457 78.5604 326.616 101.477 326.616 122.808Z",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64 165.48C299.64 183.761 286.486 208.643 265.093 228.983C243.718 249.305 214.215 264.997 181.659 264.997C165.374 264.997 152.6 261.482 142.594 255.378C132.588 249.275 125.316 240.563 120.064 230.116C109.548 209.198 107.151 181.367 107.151 153.756C107.151 126.127 110.54 109.521 121.903 99.7565C127.589 94.8702 135.316 91.6578 145.735 89.6704C156.155 87.6826 169.23 86.9269 185.579 86.9269C218.19 86.9269 246.726 97.419 267.1 112.499C287.488 127.59 299.64 147.222 299.64 165.48Z",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.895 103.047C362.895 112.836 358.645 125.822 350.894 139.825C343.151 153.817 331.939 168.777 318.081 182.504C290.356 209.967 252.097 232.439 209.883 232.439C188.761 232.439 172.184 227.869 159.191 219.925C146.2 211.982 136.76 200.645 129.944 187.057C116.302 159.857 113.198 123.681 113.198 87.8204C113.198 51.9414 117.584 30.3073 132.363 17.5779C139.757 11.2091 149.797 7.02974 163.31 4.44598C176.824 1.86186 193.776 0.880371 214.962 0.880371C257.229 0.880371 294.231 16.5907 320.664 37.2415C333.881 47.5667 344.446 59.12 351.703 70.549C358.964 81.9838 362.895 93.263 362.895 103.047Z",
    stroke: "#FAFAFA"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 61.246,
    y: 51.584,
    width: 264,
    height: 57,
    viewBox: "0 0 264 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_138_16946)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.23391,
    y: 2.29346,
    width: 257.516,
    height: 49.9055,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2339 35.2462H47.2339V20.2462C47.2339 19.981 47.1285 19.7266 46.941 19.5391C46.7535 19.3516 46.4991 19.2462 46.2339 19.2462C45.9687 19.2462 45.7143 19.3516 45.5268 19.5391C45.3393 19.7266 45.2339 19.981 45.2339 20.2462V35.2462H43.2339V28.2462C43.2339 27.981 43.1285 27.7266 42.941 27.5391C42.7535 27.3516 42.4991 27.2462 42.2339 27.2462C41.9687 27.2462 41.7143 27.3516 41.5268 27.5391C41.3393 27.7266 41.2339 27.981 41.2339 28.2462V35.2462H39.2339V24.2462C39.2339 23.981 39.1285 23.7266 38.941 23.5391C38.7535 23.3516 38.4991 23.2462 38.2339 23.2462C37.9687 23.2462 37.7143 23.3516 37.5268 23.5391C37.3393 23.7266 37.2339 23.981 37.2339 24.2462V35.2462H35.2339V32.2462C35.2339 31.981 35.1285 31.7266 34.941 31.5391C34.7535 31.3516 34.4991 31.2462 34.2339 31.2462C33.9687 31.2462 33.7143 31.3516 33.5268 31.5391C33.3393 31.7266 33.2339 31.981 33.2339 32.2462V35.2462H31.2339V18.2462C31.2339 17.981 31.1285 17.7266 30.941 17.5391C30.7535 17.3516 30.4991 17.2462 30.2339 17.2462C29.9687 17.2462 29.7143 17.3516 29.5268 17.5391C29.3393 17.7266 29.2339 17.981 29.2339 18.2462V36.2462C29.2339 36.5114 29.3393 36.7658 29.5268 36.9533C29.7143 37.1409 29.9687 37.2462 30.2339 37.2462H48.2339C48.4991 37.2462 48.7535 37.1409 48.941 36.9533C49.1285 36.7658 49.2339 36.5114 49.2339 36.2462C49.2339 35.981 49.1285 35.7266 48.941 35.5391C48.7535 35.3516 48.4991 35.2462 48.2339 35.2462Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.75,
    y: 23.2462,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.75,
    y: 21.2462,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.75,
    y: 19.2462,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F5F5F5"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 142.125,
    y: 110.8452,
    width: 335,
    height: 127,
    viewBox: "0 0 335 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_138_16944)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.7432,
    y: 13.5474,
    width: 257.516,
    height: 49.9055,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7432 42.5001C70.141 42.5001 70.5225 42.3421 70.8038 42.0608C71.0851 41.7795 71.2432 41.3979 71.2432 41.0001C71.2481 40.9502 71.2481 40.9 71.2432 40.8501L74.0332 38.0601H74.2632H74.4932L76.1032 39.6701C76.1032 39.6701 76.1032 39.7201 76.1032 39.7501C76.1032 40.1479 76.2612 40.5295 76.5425 40.8108C76.8238 41.0921 77.2054 41.2501 77.6032 41.2501C78.001 41.2501 78.3825 41.0921 78.6638 40.8108C78.9451 40.5295 79.1032 40.1479 79.1032 39.7501V39.6701L82.7432 36.0001C83.0399 36.0001 83.3299 35.9121 83.5765 35.7473C83.8232 35.5825 84.0155 35.3482 84.129 35.0741C84.2425 34.8001 84.2722 34.4985 84.2144 34.2075C84.1565 33.9165 84.0136 33.6492 83.8038 33.4395C83.5941 33.2297 83.3268 33.0868 83.0358 33.0289C82.7448 32.9711 82.4432 33.0008 82.1692 33.1143C81.8951 33.2278 81.6608 33.4201 81.496 33.6668C81.3312 33.9134 81.2432 34.2035 81.2432 34.5001C81.2383 34.55 81.2383 34.6002 81.2432 34.6501L77.6332 38.2601H77.4732L75.7432 36.5001C75.7432 36.1023 75.5851 35.7208 75.3038 35.4395C75.0225 35.1582 74.641 35.0001 74.2432 35.0001C73.8454 35.0001 73.4638 35.1582 73.1825 35.4395C72.9012 35.7208 72.7432 36.1023 72.7432 36.5001L69.7432 39.5001C69.3454 39.5001 68.9638 39.6582 68.6825 39.9395C68.4012 40.2208 68.2432 40.6023 68.2432 41.0001C68.2432 41.3979 68.4012 41.7795 68.6825 42.0608C68.9638 42.3421 69.3454 42.5001 69.7432 42.5001ZM83.2432 46.5001H66.2432V29.5001C66.2432 29.2349 66.1378 28.9806 65.9503 28.793C65.7627 28.6055 65.5084 28.5001 65.2432 28.5001C64.978 28.5001 64.7236 28.6055 64.5361 28.793C64.3485 28.9806 64.2432 29.2349 64.2432 29.5001V47.5001C64.2432 47.7653 64.3485 48.0197 64.5361 48.2072C64.7236 48.3948 64.978 48.5001 65.2432 48.5001H83.2432C83.5084 48.5001 83.7628 48.3948 83.9503 48.2072C84.1378 48.0197 84.2432 47.7653 84.2432 47.5001C84.2432 47.2349 84.1378 46.9806 83.9503 46.793C83.7628 46.6055 83.5084 46.5001 83.2432 46.5001Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.259,
    y: 34.5001,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.259,
    y: 32.5001,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.259,
    y: 30.5001,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F5F5F5"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 2.512,
    y: 190.628,
    width: 265,
    height: 57,
    viewBox: "0 0 265 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_138_16947)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.741,
    y: 2.54712,
    width: 257.516,
    height: 49.9055,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.741 35.4999H47.741V20.4999C47.741 20.2347 47.6356 19.9803 47.4481 19.7928C47.2606 19.6052 47.0062 19.4999 46.741 19.4999C46.4758 19.4999 46.2214 19.6052 46.0339 19.7928C45.8464 19.9803 45.741 20.2347 45.741 20.4999V35.4999H43.741V28.4999C43.741 28.2347 43.6356 27.9803 43.4481 27.7928C43.2606 27.6052 43.0062 27.4999 42.741 27.4999C42.4758 27.4999 42.2214 27.6052 42.0339 27.7928C41.8464 27.9803 41.741 28.2347 41.741 28.4999V35.4999H39.741V24.4999C39.741 24.2347 39.6356 23.9803 39.4481 23.7928C39.2606 23.6052 39.0062 23.4999 38.741 23.4999C38.4758 23.4999 38.2214 23.6052 38.0339 23.7928C37.8464 23.9803 37.741 24.2347 37.741 24.4999V35.4999H35.741V32.4999C35.741 32.2347 35.6356 31.9803 35.4481 31.7928C35.2606 31.6052 35.0062 31.4999 34.741 31.4999C34.4758 31.4999 34.2214 31.6052 34.0339 31.7928C33.8464 31.9803 33.741 32.2347 33.741 32.4999V35.4999H31.741V18.4999C31.741 18.2347 31.6356 17.9803 31.4481 17.7928C31.2606 17.6052 31.0062 17.4999 30.741 17.4999C30.4758 17.4999 30.2214 17.6052 30.0339 17.7928C29.8464 17.9803 29.741 18.2347 29.741 18.4999V36.4999C29.741 36.7651 29.8464 37.0194 30.0339 37.207C30.2214 37.3945 30.4758 37.4999 30.741 37.4999H48.741C49.0062 37.4999 49.2606 37.3945 49.4481 37.207C49.6356 37.0194 49.741 36.7651 49.741 36.4999C49.741 36.2347 49.6356 35.9803 49.4481 35.7928C49.2606 35.6052 49.0062 35.4999 48.741 35.4999Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.257,
    y: 23.4999,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.257,
    y: 21.4999,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.257,
    y: 19.4999,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F5F5F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_138_16946",
    x: 0.233906,
    y: 0.293457,
    width: 263.516,
    height: 55.9055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_138_16946"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_16946"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_138_16946",
    result: "effect2_dropShadow_138_16946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_138_16946",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_138_16944",
    x: 0.743179,
    y: 0.547363,
    width: 333.516,
    height: 125.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_138_16944"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_16944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_138_16944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_138_16947",
    x: 0.740997,
    y: 0.547119,
    width: 263.516,
    height: 55.9055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_138_16947"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_138_16947"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_138_16947",
    result: "effect2_dropShadow_138_16947"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_138_16947",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_48122"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 0.380371,
    width: 240,
    height: 240,
    rx: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRecommendationState);
export default __webpack_public_path__ + "static/media/empty_recommendation_state.6d269bd7c590e98cb4f926f8721db2cc.svg";
export { ForwardRef as ReactComponent };